import { useModals } from '@frontend/modal';

import { UserDetailsCardProps } from './user-details-card.component';

interface ViewProps {
    openModal: ReturnType<typeof useModals>['openModal'];
    updateModalId: string;
}

export const useUserDetailsCard = (props: UserDetailsCardProps): ViewProps => {
    const { openModal } = useModals();
    const updateModalId = 'user-details-update';

    return {
        openModal,
        updateModalId
    };
};
